import liveSeatService from "@/api/services/liveSeatService";
import {ElNotification} from 'element-plus';
import {getClipsDuration} from "@/helpers";
import sharedService from "@/api/services/sharedService";

const state = {
  is_live: null,
  live_id: null,
  stream: null,
  clips: [],
  options: null,
  loading: true,
  clips_duration: 0,
  isAdmin: localStorage.getItem("isAdmin") === 'true' || false,
}

const getters = {
  getIsLive: state => state.is_live,
  getClips: state => state.clips,
  getClipById: state => id => state.clips.find(clip => clip.id === id),
  getStream: state => state.stream,
  getLoading: state => state.loading,
  getOptions: state => state.options,
  getClipsDuration: state => state.clips_duration,
  getSeatId: state => state.stream.stream_seat_id,
  getIsAdmin: state => state.isAdmin
}

const mutations = {
  setIsLive(state, live) {
    state.is_live = live;
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  addClip(state, payload) {
    state.clips.push(payload)
    state.clips_duration = getClipsDuration(state.clips)
  },
  removeClip(state, id) {
    state.clips.splice(id, 1)
    state.clips_duration = getClipsDuration(state.clips)
  },
  clearClips(state) {
    state.clips = []
    state.clips_duration = getClipsDuration(state.clips)
  },
  updateClip(state, {id, clip}) {
    state.clips = state.clips.map(_clip => {
      if (_clip.id === id) return clip
      else return _clip
    })
    state.clips_duration = getClipsDuration(state.clips)
  },
  applyEffectToClip(state, {id, transition}) {
    state.clips = state.clips.map(clip => {
      if (clip.id !== id) return clip;
      return {...clip, transition: transition}
    })
    state.clips_duration = getClipsDuration(state.clips)
  },
  setStream(state, payload) {
    if(!payload) {
      state.stream = null
      return
    }
    state.stream = {...payload, start_timestamp: Number(payload.start_timestamp * 1000)}
    state.live_id = payload.id
    state.clips = payload.clips?.map(clip => {
      return {
        ...clip,
        startTimestamp: clip.startTimestamp * 1000,
        endTimestamp: clip.endTimestamp * 1000,
        trim: clip.trim ? {
          start: clip.trim.start * 1000,
          end: clip.trim.end * 1000,
        } : null,
      }
    }) || []
    state.clips_duration = getClipsDuration(state.clips)
    if (payload.options) state.options = {...payload.options, video_duration: (getClipsDuration(state.clips) / 1000)}

  },
  setOptions(state, payload) {
    state.options = payload
  }
}

const actions = {
  async createClip({commit, state}, payload) {
    commit('addClip', payload)
    sharedService.videoProxy(state.stream.stream_seat_id, payload.startTimestamp / 1000, payload.endTimestamp / 1000).then(res => {
      if(res.status === 200) {
        commit('updateClip', {id: payload.id, clip: {...payload, video_url: res.data.video_url, loading: false, duration: res.data.duration}})
      } else {
        commit('updateClip', {id: payload.id, clip: {...payload, loading: false, failed: true}})
      }
    })
  },
  applyEffectToAll({commit, state}, transition) {
    state.clips.map((clip, index) => {
      if ((clip.transition && !transition?.override) || index === (state.clips.length - 1)) return;
      commit('applyEffectToClip', {id: clip.id, transition: transition})
    })
    state.clips_duration = getClipsDuration(state.clips)
  },
  removeEffectFromAll({commit, state}) {
    state.clips.map(clip => {
      commit('applyEffectToClip', {id: clip.id, transition: null})
    })
    state.clips_duration = getClipsDuration(state.clips)
  },
  async getRecord({commit, dispatch}, payload) {
    return await liveSeatService.getRecordById(payload.seatId).then(async ({data}) => {
      if (data.stream) {
        await commit('setStream', data.stream)
      } else {
        await dispatch('creatRecord', payload)
      }
      return true
    }).catch(error => {
      console.log(error)
      return false
    })
  },
  cancelRecord() {
    return liveSeatService.cancelRecord(state.live_id)
  },
  publishRecord() {
    return liveSeatService.publishRecord(state.live_id)
  },
  async creatRecord({commit}, payload) {
    await liveSeatService.createRecord(payload).then(({data}) => {
      commit('setStream', data)
    })
  },
  async preview({dispatch, state, commit}) {
    commit('setLoading', true)
    try {
      if (state.options.has_watermark) {
        let res = await dispatch('editor/uploadImage', state.options.watermark_image, {root: true})
        if (res.status === 200) {
          state.options.watermark_image_url = res.data.imageUrl || state.options.watermark_image_url
          state.options.watermark_image = res.data.image
        } else {
          ElNotification({
            type: 'error',
            title: 'Error',
            message: "Watermark | " + res.data.errors?.map(({msg}) => msg).join('\n'),
            offset: 100
          })
          return {status: false};
        }
      }
      const data = {
        id: state.stream.id,
        seatId: state.stream.stream_seat_id,
        clips: state.clips.map(clip => clearClip(clip)),
        options: state.options
      }
      return await liveSeatService.createPreview(data)

    } catch (e) {
      console.error(e)
      ElNotification({
        type: 'error',
        title: 'Error',
        message: e.message || 'Something when wrong',
        offset: 100
      })
    } finally {
      console.log('Finish')
      state.loading = false;
    }
  }
}

function clearClip(clip) {
  return {
    ...clip,
    startTimestamp: Math.round(clip.startTimestamp / 1000),
    endTimestamp: Math.round(clip.endTimestamp / 1000),
    trim: clip.trim ? {
      start: clip.trim?.start ? clip.trim.start / 1000 : 0,
      end: clip.trim?.end ? clip.trim.end / 1000 : clip.duration
    } : null,
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
